import { __decorate, __param } from '../../../../../../../external/tslib/tslib.es6.js';
import { IContextKeyService } from 'monaco-editor/esm/vs/platform/contextkey/common/contextkey.js';
import { Registry } from 'monaco-editor/esm/vs/platform/registry/common/platform.js';
import { Extensions } from '../../../common/contributions.js';
let ListContext = class ListContext {
    constructor(contextKeyService) {
        contextKeyService.createKey('listSupportsTypeNavigation', true);
        contextKeyService.createKey('listSupportsKeyboardNavigation', true);
    }
};
ListContext = ( __decorate([
    ( __param(0, IContextKeyService))
], ListContext));
( Registry.as(Extensions.Workbench)).registerWorkbenchContribution(ListContext, 1 );
export { ListContext };
